import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '@app/core/services/auth.service';
import { sanitizeReturnUrl } from '@app/core/utils';

/**
 * Keeps signed-in admins off the login page. A safe `returnUrl` is honoured
 * so a deep link that bounced through login still reaches its target.
 */
export const guestGuard: CanActivateFn = (route) => {
  const authService = inject(AuthService);
  const router = inject(Router);

  if (authService.isAuthenticated()) {
    const returnUrl = sanitizeReturnUrl(route.queryParamMap.get('returnUrl'));
    return router.parseUrl(returnUrl ?? '/dashboard');
  }

  return true;
};
